import {Component, Input} from '@angular/core';
import {IconComponent} from '../../icons/icon.component';
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-context-menu',
  imports: [
    IconComponent,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    TranslatePipe
  ],
  templateUrl: './context-menu.component.html',
  styleUrl: './context-menu.component.scss'
})
export class ContextMenuComponent {
  @Input() menuItems: ContextMenuData[] = [];
}

export interface ContextMenuData {
  labelKey: string,
  action: () => void,
  disabled?: boolean,
}
